import { APIClient } from 'infra/APIClient'
import { APIConfig, CursorPaged } from 'types/definitions'
import {
  UpdateNotificationPreferencesPayload,
  SetNotificationStatusPayload,
  NotificationDTO,
  FindNotificationsQuery,
  NotificationPreferences,
} from './dtos/notifications'
import { rethrowRequestError } from 'utils/error-util'

export interface NotificationsAPIRoot {
  notifications: NotificationAPI
  preferences: NotificationPreferencesAPI
}

export function createNotificationsAPI(opts: APIConfig): NotificationsAPIRoot {
  return {
    notifications: new NotificationAPI(opts),
    preferences: new NotificationPreferencesAPI(opts),
  }
}

export class NotificationAPI extends APIClient {
  find(params: FindNotificationsQuery): Promise<CursorPaged<NotificationDTO>> {
    return this.client
      .get('/v3/notifications', { params })
      .then(this._data)
      .catch(rethrowRequestError)
  }

  changeStatus(
    params: SetNotificationStatusPayload,
  ): Promise<NotificationDTO | null> {
    return this.client
      .post(`/v3/notifications/${params.id}/status`, params)
      .then(this._data)
      .catch(rethrowRequestError)
  }

  changeStatusBulk(
    payload: Array<SetNotificationStatusPayload>,
  ): Promise<Array<NotificationDTO>> {
    return this.client
      .post('/v3/notifications/status', payload)
      .then(this._data)
      .catch(rethrowRequestError)
  }
}

export class NotificationPreferencesAPI extends APIClient {
  get({
    workspace_id,
    user_public_id,
  }: {
    workspace_id: string
    user_public_id: string
  }): Promise<NotificationPreferences> {
    return this.client
      .get(
        `/v3/workspaces/${workspace_id}/members/${user_public_id}/preferences`,
      )
      .then(this._data)
      .catch(rethrowRequestError)
  }

  patch(
    { workspace_id, user_id = 'me' }: { workspace_id: string; user_id: string },
    payload: UpdateNotificationPreferencesPayload,
  ): Promise<NotificationPreferences> {
    return this.client
      .patch(
        `/v3/workspaces/${workspace_id}/members/${user_id}/preferences`,
        payload,
      )
      .then(this._data)
      .catch(rethrowRequestError)
  }
}
